import { createTheme, responsiveFontSizes } from '@mui/material/styles';

// Deep, calm blue palette — professional, developer/IT feel.
let theme = createTheme({
  palette: {
    primary: {
      main: '#1f6feb',
      light: '#4f90f5',
      dark: '#0d2f6b',
    },
    secondary: {
      main: '#2bb3a3',
      light: '#5fd0c2',
      dark: '#1b7a6f',
    },
    background: {
      default: '#f6f8fb',
      paper: '#ffffff',
    },
    text: {
      primary: '#0f1e33',
      secondary: '#5a6b82',
    },
    divider: 'rgba(15, 30, 51, 0.08)',
  },
  typography: {
    fontFamily: ['Inter', 'Roboto', 'system-ui', 'Arial', 'sans-serif'].join(','),
    h1: { fontWeight: 800, letterSpacing: '-1.5px' },
    h2: { fontWeight: 800, letterSpacing: '-1px' },
    h3: { fontWeight: 700, letterSpacing: '-0.5px' },
    h4: { fontWeight: 700, letterSpacing: '-0.25px' },
    h5: { fontWeight: 600 },
    h6: { fontWeight: 600 },
    button: { fontWeight: 600, textTransform: 'none' },
    overline: { fontWeight: 700, letterSpacing: 1.5 },
  },
  shape: { borderRadius: 12 },
  components: {
    MuiButton: {
      styleOverrides: {
        root: { boxShadow: 'none' },
        contained: { padding: '11px 24px' },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          boxShadow: 'none',
          border: '1px solid rgba(15, 30, 51, 0.08)',
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: { boxShadow: 'none' },
      },
    },
  },
});

theme = responsiveFontSizes(theme);

export default theme;
